<script lang="ts">
export function displayText(user?: UserSlim) {
  if (!user) {
    return 'Unknown'
  }
  if (user.displayName && user.email) {
    return `${user.displayName} (${user.email})`
  }
  return user.displayName ?? user.email ?? 'Unknown'
}
</script>

<script setup lang="ts">
import { type UserSlim } from '../model'
import UserAvatar from './UserAvatar.vue'

const props = defineProps<{
  user?: UserSlim
  onClear?: (payload: PointerEvent) => void
}>()
</script>

<template>
  <div :data-testid="`user-${user?.userId}`" class="flex min-w-0 items-center">
    <UserAvatar :user="user" :on-clear="onClear" />
    <span class="ml-2 min-w-0 truncate" data-testid="display-name">{{ displayText(user) }}</span>
  </div>
</template>
